module.exports = __webpack_public_path__ + "img/Check4.3895b420.png";